<script lang="ts">
	import { box, mergeProps } from "svelte-toolbelt";
	import { useCalendarHeading } from "./calendar.svelte.js";
	import { useId } from "./internal/use-id.js";

	let {
		children,
		child,
		ref = $bindable(null),
		id = useId(),
		...restProps
	} = $props();

	const headingState = useCalendarHeading({
		id: box.with(() => id),
		ref: box.with(
			() => ref,
			(v) => (ref = v)
		),
	});

	const mergedProps = $derived(mergeProps(restProps, headingState.props));
</script>

{#if child}
	{@render child({ props: mergedProps, headingValue: headingState.headingValue })}
{:else}
	<div {...mergedProps}>
		{#if children}
			{@render children?.({ headingValue: headingState.headingValue })}
		{:else}
			{headingState.headingValue}
		{/if}
	</div>
{/if}
